<br>
<div class="col-md-12" style="min-width:1300px;">
  <p-table #dt [columns]="cols" [value]="offices" [paginator]="false" [autoLayout]="true" [scrollable]="false" [style]="{width:'100%'}">
    <ng-template pTemplate="caption">
      <p class="rubrik">Hantera Office</p>
      <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
            (click)="exportToCSV()">Excel</button><button class="btn border" (click)="addOffice();">Lägg till</button></div>
      <br>
      <div>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      <span class="ms-2">Antal poster: {{offices?.length}}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr style="background-color: whitesmoke;font-weight:bold;border:1px solid lightgrey;">
        <td colspan="3" style="border:1px solid lightgrey;">Ämbetstyp</td>
        <td colspan="5" style="border:1px solid lightgrey;">Ämbete</td>
        <td colspan="2" style="border:1px solid lightgrey;"></td>
      </tr>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th>Action</th>
      </tr>
      <tr *ngIf="isactivelist.length > 0 && roles.length > 0 && types.length > 0">
        <th *ngFor="let col of columns" [ngSwitch]="col.field">
          <input *ngSwitchCase="'name'" pInputText type="text" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'abbreviation'" pInputText type="text" [value]="dt.filters['abbreviation'] ? dt.filters['abbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'officeTypeAbbreviation'" pInputText type="text" [value]="dt.filters['officeTypeAbbreviation'] ? dt.filters['officeTypeAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'email'" pInputText type="text" [value]="dt.filters['email'] ? dt.filters['email'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <!--p-triStateCheckbox *ngSwitchCase="'isActive'" [(ngModel)]="value" [style]="{'width':'100%'}" (onChange)="dt.filter(value, col.field, 'equals')"></p-triStateCheckbox-->
          <p-select #fullypaid appendTo="body" *ngSwitchCase="'isActive'" [options]="isactivelist" [autoWidth]="false" [style]="{'maxWidth':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'isActive', 'equals')"></p-select>

<!--p-checkbox
  *ngSwitchCase="'isActive'"
  [style]="{'width':'100%'}"
  [binary]="true"
  [indeterminate]="value === null"
  [ngModel]="value"
  (onChange)="cycleTriState(); dt.filter(value, col.field, 'equals')">
</p-checkbox-->

<!--test-->

          <p-select appendTo="body" *ngSwitchCase="'roleDescription'" [options]="roles" [style]="{'width':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'roleId', 'equals')"></p-select>
          <p-select appendTo="body" *ngSwitchCase="'officeTypeName'" [options]="types" [style]="{'width':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'officeTypeId', 'equals')"></p-select>
          <!--p-multiSelect *ngSwitchCase="'abbreviation'" [options]="colors" defaultLabel="All Colors" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect-->
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          <span *ngIf="rowData[col.field]!==true && rowData[col.field]!==false">
            {{rowData[col.field]}}</span>
          <div *ngIf="rowData[col.field] === true" style="text-align: center;">
            <i class="fa fa-check" style="color: green; font-size: 12px;font-weight: bold;" title="true"></i>
          </div>
          <div *ngIf="rowData[col.field] === false" style="text-align: center;">
            <i class="fa fa-times" style="color: red; font-size: 12px;font-weight: bold;" title="false"></i>
          </div>
        </td>
        <td><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera aktuellt ämbete"></i><i class="fa fa-edit" style="font-size:12px;margin-left:10px;" (click)="edit(rowData)" title="Ändra aktuellt ämbete"></i></span></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Editera uppdrag" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-offices-edit [formdata]="formdata" [roles]="roles" [types]="types" (doSave)="saveOffice($event)" (doCancel)="cancelEdit()"></app-admin-offices-edit>
</p-dialog>

<p-dialog header="Lägg till uppdrag" [(visible)]="displayaddoffice" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-offices-add [formdata]="formdata" [roles]="roles" [types]="types" (doSave)="saveAddOffice($event)" (doCancel)="cancelAdd()"></app-admin-offices-add>
</p-dialog>
